module.exports = __webpack_public_path__ + "static/media/no-profile-img.4008c711.svg";